module.exports = __webpack_public_path__ + "static/img/alimentarius.efa6afb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/alimentarius.jpg
// module id = TddD
// module chunks = 0